import * as io from "io-ts";
import { BlockImport, BlockModel } from ".";
import { withMessage } from "io-ts-types";
import t from "../../../../../i18n";

export const BlockPresetKind = withMessage(io.strict({ kind: io.literal("PRESET") }), () =>
  t("schema.block.kind"),
);

const PresetBlockDataCommon = io.type({
  title: io.string,
});

const PriorityFaultEventsPresetBlockData = io.intersection([
  PresetBlockDataCommon,
  io.type({
    preset: io.literal("PRIORITY_FAULT_EVENTS"),
    systemIds: io.array(io.string),
  }),
]);

const DefaultPresetBlockData = io.intersection([
  PresetBlockDataCommon,
  io.type({
    preset: io.keyof({
      AVERAGE_LOSSES: null,
      PRODUCTION_MONITORING: null,
      FINANCIAL_IMPACT: null,
      ANOMALY_DETECTION_LAST_WEEK_ALERTS: null,
    }),
  }),
]);

export const PresetBlockData = io.union([
  PriorityFaultEventsPresetBlockData,
  DefaultPresetBlockData,
]);

export const BlockPresetData = io.type({
  data: PresetBlockData,
});

export const BlockPresetModel = io.intersection([BlockModel, BlockPresetKind, BlockPresetData]);

export const BlockPresetImport = io.intersection([BlockImport, BlockPresetKind, BlockPresetData]);

export type BlockPresetModelT = io.TypeOf<typeof BlockPresetModel>;
export type BlockPresetImportT = io.TypeOf<typeof BlockPresetImport>;
